import { environment } from 'environments/environment';

export const Profiles: any[] = [
    {
        'id': 'customer',
        'display': 'Customer',
    },{
        'id': 'administrator',
        'display': 'Administrator',
    },{
        'id': 'callcentre',
        'display': 'Call Centre',
    },{
        'id': 'finance',
        'display': 'Finance',
    },{
        'id': 'parkingEnforcement',
        'display': 'Parking Enforcement',
    },{
        'id': 'parkingEnforcerWithMeter',
        'display': 'Parking Enforcer With Meter',
    },{
        'id': 'ePermitsIntegrationAPI',
        'display': 'EPermits Integration API',
    },{
        'id': 'parkingEvent',
        'display': 'Parking Event',
    }
];

export const UserSearchOptions : any[] = [
    {
        'id': 2,
        'display': 'Email Address'
    },
    {
        'id': 6,
        'display': 'Masked Card Number'
    },
    {
        'id': 3,
        'display': 'Mobile Number'
    },
    {
        'id': 5,
        'display': 'Payment Account ID'
    },
    {
        'id': 1,
        'display': 'Username'
    },
    {
        'id': 4,
        'display': 'Vehicle Registration'
    },
];

export const AdminSearchOptions : any[] = [
    {
        'id': 2,
        'display': 'Email Address'
    },
    {
        'id': 1,
        'display': 'Username'
    }
];

export const GuestUserTransactionSearchOptions : any[] = [
    {
        'id': 1,
        'display': 'Mobile Number'
    },
    {
        'id': 2,
        'display': 'Vehicle Registration'
    }
];

export const ReminderOption : any[] = [
    // {
    //     'id': 1,
    //     'display': 'Always send'
    // },
    {
        'id': 2,
        'display': 'Never send'
    },
    {
        'id': 3,
        'display': 'Choose each time'
    }
];

export const PTagAccountStatus: any[] = [
    {
        'id': 1,
        'description': 'Active'
    },
    {
        'id': 2,
        'description': 'Disabled'
    },
    {
        'id': 3,
        'description': 'Deleted'
    }
];

export const UserAccountStatus: any[] = [
    {
        'id': 0,
        'description': 'Disabled'
    }, {
        'id': 10,
        'description': 'Awaiting Activation'
    }, {
        'id': 20,
        'description': 'Enabled'
    }, {
        'id': 30,
        'description': 'Deleted'
    }
];

// Note - If add new state, update STATES_NO_SPECIAL below
export const STATES: any[] = [
    {
        'name': 'ACT',
        'display': 'Australian Capital Territory'
    }, {
        'name': 'NSW',
        'display': 'New South Wales'
    }, {
        'name': 'NT',
        'display': 'Northern Territory'
    }, {
        'name': 'QLD',
        'display': 'Queensland'
    }, {
        'name': 'SA',
        'display': 'South Australia'
    }, {
        'name': 'TAS',
        'display': 'Tasmania'
    }, {
        'name': 'VIC',
        'display': 'Victoria'
    }, {
        'name': 'WA',
        'display': 'Western Australia'
    }, {
        'name': 'O',
        'display': 'Overseas'
    }, {
        'name': 'NHV',
        'display': 'National Heavy Vehicle'
    }, {
        'name': 'FED',
        'display': 'Federal'
    }
];

/** Ignore non-real states (used for residential address states) */
export const STATES_NO_SPECIAL: any[] = STATES.slice(0, STATES.length - 2);

export const MonthEnum: any[] = [

    {
        value: '1',
        display: 'January'
    },
    {
        value: '2',
        display: 'February'
    },
    {
        value: '3',
        display: 'March'
    },
    {
        value: '4',
        display: 'April'
    },
    {
        value: '5',
        display: 'May'
    },
    {
        value: '6',
        display: 'June'
    },
    {
        value: '7',
        display: 'July'
    },
    {
        value: '8',
        display: 'August'
    },
    {
        value: '9',
        display: 'September'
    },
    {
        value: '10',
        display: 'October'
    },
    {
        value: '11',
        display: 'November'
    },
    {
        value: '12',
        display: 'December'
    }
];

export const Times : any[] = [
    {
        'value': '00:00:00',
        'display': '00:00'
    }, {
        'value': '00:30:00',
        'display': '00:30'
    }, {
        'value': '01:00:00',
        'display': '01:00'
    }, {
        'value': '01:30:00',
        'display': '01:30'
    }, {
        'value': '02:00:00',
        'display': '02:00'
    }, {
        'value': '02:30:00',
        'display': '02:30'
    }, {
        'value': '03:00:00',
        'display': '03:00'
    }, {
        'value': '03:30:00',
        'display': '03:30'
    }, {
        'value': '04:00:00',
        'display': '04:00'
    }, {
        'value': '04:30:00',
        'display': '04:30'
    }, {
        'value': '05:00:00',
        'display': '05:00'
    }, {
        'value': '05:30:00',
        'display': '05:30'
    }, {
        'value': '06:00:00',
        'display': '06:00'
    }, {
        'value': '06:30:00',
        'display': '06:30'
    }, {
        'value': '07:00:00',
        'display': '07:00'
    }, {
        'value': '07:30:00',
        'display': '07:30'
    }, {
        'value': '08:00:00',
        'display': '08:00'
    }, {
        'value': '08:30:00',
        'display': '08:30'
    }, {
        'value': '09:00:00',
        'display': '09:00'
    }, {
        'value': '09:30:00',
        'display': '09:30'
    }, {
        'value': '10:00:00',
        'display': '10:00'
    }, {
        'value': '10:30:00',
        'display': '10:30'
    }, {
        'value': '11:00:00',
        'display': '11:00'
    }, {
        'value': '11:30:00',
        'display': '11:30'
    }, {
        'value': '12:00:00',
        'display': '12:00'
    }, {
        'value': '12:30:00',
        'display': '12:30'
    }, {
        'value': '13:00:00',
        'display': '13:00'
    }, {
        'value': '13:30:00',
        'display': '13:30'
    }, {
        'value': '14:00:00',
        'display': '14:00'
    }, {
        'value': '14:30:00',
        'display': '14:30'
    }, {
        'value': '15:00:00',
        'display': '15:00'
    }, {
        'value': '15:30:00',
        'display': '15:30'
    }, {
        'value': '16:00:00',
        'display': '16:00'
    }, {
        'value': '16:30:00',
        'display': '16:30'
    }, {
        'value': '17:00:00',
        'display': '17:00'
    }, {
        'value': '17:30:00',
        'display': '17:30'
    }, {
        'value': '18:00:00',
        'display': '18:00'
    }, {
        'value': '18:30:00',
        'display': '18:30'
    }, {
        'value': '19:00:00',
        'display': '19:00'
    }, {
        'value': '19:30:00',
        'display': '19:30'
    }, {
        'value': '20:00:00',
        'display': '20:00'
    }, {
        'value': '20:30:00',
        'display': '20:30'
    }, {
        'value': '21:00:00',
        'display': '21:00'
    }, {
        'value': '21:30:00',
        'display': '21:30'
    }, {
        'value': '22:00:00',
        'display': '22:00'
    }, {
        'value': '22:30:00',
        'display': '22:30'
    }, {
        'value': '23:00:00',
        'display': '23:00'
    }, {
        'value': '23:30:00',
        'display': '23:30'
    }, {
        'value': '23:59:59',
        'display': '23:59'
    }
];

export enum CardType {
  VISA = "VISA",
  MASTERCARD = "MasterCard",
  AMEX = "AMEX",
  DINERS = "Diners"
}

export enum PromotionStatus {
    All = -1,
    Active = 1,
    NonActive = 0,
    Expired = 2,
    UpComing = 3
}

function getPayStayCards(): any[] {
    let result: any[] = [
        {
            value: "visa",
            type: CardType.VISA,
            display: "VISA",
            logoUrl: "/assets/img/icons/Visa.svg"
        },
        {
            value: "mastercard",
            type: CardType.MASTERCARD,
            display: "MasterCard",
            logoUrl: "/assets/img/icons/MasterCard.svg"
        }
    ];

    if (environment.amexEnabled) {
        result.push(
            {
                value: "amex",
                type: CardType.AMEX,
                display: "American Express",
                logoUrl: "/assets/img/icons/AMEX.svg"
            }
        );
    }

    return result;
}

export const PayStayCards: any[] = getPayStayCards();

export const ATParkCards: any[] = [
    {
        value: "visa",
        type: CardType.VISA,
        display: "VISA",
        logoUrl: "/assets/img/icons/Visa.png"
    },
    {
        value: "mastercard",
        type: CardType.MASTERCARD,
        display: "MasterCard",
        logoUrl: "/assets/img/icons/MasterCard.png"
    },
    {
        value: "amex",
        type: CardType.AMEX,
        display: "Amex",
        logoUrl: "/assets/img/icons/AMEX.png"
    },
    {
        value: "Diners",
        type: CardType.DINERS,
        display: "Diners",
        logoUrl: "/assets/img/icons/diners.png"
    },
];

export enum ChannelType {
    ONCE = 1,
    REPLAY = 2
}

export const ExportOptions : any[] = [
    {
        value: 'pdf',
        display: 'PDF'
    },
    {
        value: 'xls',
        display: 'XLS'
    },
    {
        value: 'csv',
        display: 'CSV'
    }
];

export const PreDefinedExportOptions : any[] = [
    {
        value : "Last Week",
        display: "Last Week"


    },
    {
        value : "Last Month",
        display: "Last Month"


    }
]

export const PredefineOptions : any[] = [
    {
        value: 'lastweek',
        display: 'Last Week'
    },
    {
        value: 'lastmonth',
        display: 'Last Month'
    }
];

export enum AccountReviewType {
    CreditAndRefund = 0,
    Credit = 1,
    Refund = 2
}

export enum ReportNames {
    TransactionDateReport = 'TransactionDateReport',
    TransactionZoneReport = 'TransactionZoneReport'
}

export const TransactionType: any[] = [
    {
        value : 'All',
        display: 'All'
    },
    {
        value : 'ParkingSessions',
        display: 'Parking Sessions'
    },
    {
        value : 'ParkingMeter',
        display: 'Parking Meter'
    },
    {
        value : 'EPermit',
        display: 'EPermit'
    }
];

export const DayOfWeek : any[] = [
    {
        value: 0,
        display: 'Sunday'
    },{
        value: 1,
        display: 'Monday'
    },{
        value: 2,
        display: 'Tuesday'
    },{
        value: 3,
        display: 'Wednesday'
    },{
        value: 4,
        display: 'Thursday'
    },{
        value: 5,
        display: 'Friday'
    },{
        value: 6,
        display: 'Saturday'
    }
];

// Some DB tables use 0 day value to indicate a row is archived
export const DayOfWeek_1_Indexed = [
    {
        value: 1,
        display: 'Sunday'
    },
    {
        value: 2,
        display: 'Monday'
    },
    {
        value: 3,
        display: 'Tuesday'
    },
    {
        value: 4,
        display: 'Wednesday'
    },
    {
        value: 5,
        display: 'Thursday'
    },
    {
        value: 6,
        display: 'Friday'
    },
    {
        value: 7,
        display: 'Saturday'
    }
];

export enum ParkingEventStatus {
    PendingPayment = 'pending_payment',
    PaymentFailed = 'payment_failed'
}

export const AccountsReportType : any[] = [
    {
        value: 'registeredUsers',
        display: 'Registered Users'
    },
    {
        value: 'userTransactions',
        display: 'User Transactions'
    }
];

export enum OmniPages {
  landing,
  splash,
  summary,
  extensionTime,
  paymentType,
  confirmPayment,
  successfulPayment,
  invoice,
  extensionReminder,
  enterMobile,
  extendNotAvailable
}

export enum PaymentTypeEnum{
  applePay,
  creditCard,
  googlePay
}
